import React from 'react';
import { pickDataAttributes } from '@gafe/common-ui';
import merge from 'classnames';

import { formatPriceWithCurrency } from '@/utils/format-price';

import styles from './OrderDetails.module.scss';

export type Props = {
  title: string;
  value: number;
  classes?: Partial<{
    wrapper: string;
    contentWrapper: string;
    headerWrapper: string;
    bodyWrapper: string;
    headerText: string;
  }>;
  hideValue?: boolean;
  children?: React.ReactNode;
};

export const OrderDetails = ({
  classes = {},
  title,
  value,
  hideValue = false,
  children,
  ...props
}: Props) => (
  <div className={merge(styles.wrapper, classes?.wrapper)} {...pickDataAttributes(props)}>
    <div className={merge(styles.order_list_wrapper, classes?.contentWrapper)}>
      <div className={merge(styles.order_list_header, classes?.headerWrapper)}>
        <span className={merge(styles.order_list_header_item, classes?.headerText)}>{title}</span>
        {value >= 0 && !hideValue && (
          <span className={merge(styles.order_list_header_item, classes?.headerText)}>
            {formatPriceWithCurrency(value)}
          </span>
        )}
      </div>
      <div className={merge(styles.order_list_body, classes?.bodyWrapper)}>{children}</div>
    </div>
  </div>
);
